const INITIAL_STATE = {
  groupsList: [],
  totalRecords: 0,
  groupListLoading: false,
  groupDetails: {}, // contains: { customers, providers, groupHeading, sessions, sessionNotes, totalCount }
  groupDetailsLoading: false,
  groupCustomers: [],
  groupCustomersLoading: false,
  isSocialGroup: false,
  groupDetailsController: null,
};

const groupReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "FETCH_GROUPS_LIST":
      return {
        ...state,
        groupsList: [...state?.groupsList, ...action.payload.data],
        totalRecords: action.payload.totalRecords,
        groupListLoading: false,
      };
    case "RESET_GROUPS_LIST":
      return { ...state, groupsList: [], totalRecords: 0 };
    case "GROUP_LIST_LOADING":
      return { ...state, groupListLoading: action.payload };
    case "GROUP_DETAILS":
      return {
        ...state,
        groupDetails: action.payload,
        groupDetailsLoading: false,
        isSocialGroup:
          action.payload?.groupHeading?.is_new_social_group ?? false,
        groupDetailsController: action.controller,
      };
    case "RESET_GROUP_DETAILS":
      return { ...state, groupDetails: {} };
    case "GROUP_DETAILS_LOADING":
      return { ...state, groupDetailsLoading: action.payload };
    case "GROUP_CUSTOMERS_LOADING":
      return { ...state, groupCustomersLoading: true };
    case "GROUP_INDIVIDUAL_CUSTOMERS":
      return {
        ...state,
        groupCustomers: action.payload.data,
        groupCustomersLoading: false,
      };
    case "RESET_INDIVIDUAL_CUSTOMERS":
      return { ...state, groupCustomers: [] };
    case "IS_SOCIAL_GROUP":
      return { ...state, isSocialGroup: action.payload };
    default:
      return state;
  }
};

export default groupReducer;
